{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Ver todas las opciones",
  "Spoiler_Reveal_Tooltip": "Haz clic para revelar",
  "VerticalEmbed_Event_Error_Subtitle": "Este evento se ha eliminado, reemplázalo por otro.",
  "Viewer_Toolbar_Twitter_Tooltip": "Tuitea esto",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "El elemento está contraído",
  "Spoiler_Reveal_Video_CTA": "Mostrar video",
  "VerticalEmbed_Pricing_Plan": "Solo el plan",
  "Image_Expand_Button_AriaLabel": "Expandir imagen",
  "VerticalEmbed_From_Price": "Desde",
  "Poll_Viewer_ShowAllResults_CTA": "Ver todos los resultados",
  "Spoiler_Reveal_Image_Placeholder": "La imagen contiene un spoiler",
  "VerticalEmbed_Ribbon": "Oferta",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Control deslizante de búsqueda",
  "VerticalEmbed_Error_Subtitle": "Este ítem se ha eliminado, reemplázalo por otro ítem.",
  "Poll_Viewer_Multiselect_Footer": "Puedes votar por más de una respuesta.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Mostrar más controles de audio",
  "VerticalEmbed_Booking_Fetch_Error_Title": "No se pudo cargar el servicio",
  "Fullscreen_Close_Button_AriaLabel": "Cerrar",
  "VerticalEmbed_Event_Fetch_Error_Title": "No se pudo cargar el evento",
  "UploadFile_Viewer_Loader": "Cargando {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "Avatar del usuario",
  "Preview_ReadMore_Label": "Leer más",
  "Spoiler_Insert_Tooltip": "Spoiler",
  "VerticalEmbed_Product_Fetch_Error_Title": "No se pudo cargar el producto",
  "Fullscreen_Shrink_Button_AriaLabel": "Reducir",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Volumen",
  "Spoiler_Reveal_Gallery_Placeholder": "Esta galería contiene un spoiler",
  "Fullscreen_Expand_Button_AriaLabel": "Expandir",
  "VerticalEmbed_Bookings_Button": "Reservar ahora",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Dejar de silenciar",
  "Spoiler_Reveal_Gallery_CTA": "Mostrar galería",
  "Poll_Viewer_ShowLess_CTA": "Mostrar menos",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Silenciar",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} anónimos",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Seguir",
  "VerticalEmbed_Products_Button": "Comprar ahora",
  "Poll_Viewer_Toast_Error_ServerDown": "No se pudo conectar al servidor. Inténtalo de nuevo más tarde.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} personas votaron por esta respuesta",
  "Poll_Viewer_VoteCount": "{{number}} votos",
  "VerticalEmbed_Events_Button": "Registrarse",
  "Spoiler_Reveal_Image_CTA": "Mostrar imagen",
  "Poll_Viewer_Toast_Error_Connection": "No hay internet. Verifica tu conexión.",
  "Poll_Viewer_Visibility_Owner_Footer": "Solo tú puedes ver los resultados.",
  "VerticalEmbed_Booking_Error_Title": "Servicio eliminado",
  "VerticalEmbed_Product_Error_Title": "Producto eliminado",
  "VerticalEmbed_Fetch_Error_Subtitle": "No se puede cargar la información del ítem.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} personas votaron por esta respuesta",
  "VerticalEmbed_Event_Error_Title": "Evento eliminado",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "El elemento está expandido",
  "Audio_Plugin_Cover_Alt": "Portada de audio",
  "Spoiler_Reveal_Video_Placeholder": "Este video contiene un spoiler",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Hubo un problema técnico. Comprueba tu conexión a Internet y vuelve a intentarlo.",
  "VerticalEmbed_Fetch_Error_Title": "No se pudo cargar el ítem",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "Este producto se ha eliminado, reemplázalo por otro producto.",
  "VerticalEmbed_Booking_Error_Subtitle": "Este servicio se ha eliminado. Reemplázalo por otro.",
  "Preview_SeeFullPost_Label": "Ver la entrada completa",
  "UploadFile_Viewer_Download": "Descargar {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}}h",
  "VerticalEmbed_Units_Minute": "{{minutes}}min",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Hubo un problema técnico. Comprueba tu conexión a Internet y vuelve a intentarlo.",
  "VerticalEmbed_Error_Button": "Reemplazar",
  "VerticalEmbed_Error_Title": "Ítem eliminado",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Hubo un problema técnico. Comprueba tu conexión a Internet y vuelve a intentarlo.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
